import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import apiClient from "../utils/apiClient";
import Select from "react-select";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";

const SeriesMaster = () => {
  const [seriesList, setSeriesList] = useState({
    startNumber: "",
    endingNumber: "",
  });
  const [editId, setEditId] = useState("");

  // Department states
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const token = localStorage.getItem("token");
  const code = localStorage.getItem("code");
  const sewadarId = localStorage.getItem("sewadarId");
  const email = localStorage.getItem("email");
  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state?.row;

  /* ---------------- EDIT MODE ---------------- */
  useEffect(() => {
    if (rowData) {
      setEditId(rowData.id);
      setSeriesList({
        startNumber: rowData.startingNo,
        endingNumber: rowData.endingNo,
      });

      if (rowData.departmentId) {
        setSelectedDepartment({
          value: rowData.departmentId,
          label: rowData.departmentName,
        });
      }
    }
  }, [rowData]);

  /* ---------------- FETCH DEPARTMENTS ---------------- */
  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      setLoadingDepartments(true);
      if (!token) return;

      const res = await apiClient.get(`${SERVER_BASE}/departments`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { code },
      });

      setDepartments(res.data || []);
    } catch (err) {
      console.error("Department fetch error:", err);
    } finally {
      setLoadingDepartments(false);
    }
  };

  const handleChange = (field, value) => {
    setSeriesList((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!seriesList.startNumber || seriesList.startNumber <= 0) {
      return Swal.fire({
        icon: "error",
        text: "Starting Number must be a positive value!",
        toast: true,
        position: "top-end",
        timer: 4000,
        showConfirmButton: false,
      });
    }

    if (!seriesList.endingNumber || seriesList.endingNumber <= 0) {
      return Swal.fire({
        icon: "error",
        text: "Ending Number must be a positive value!",
        toast: true,
        position: "top-end",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar:true
      });
    }

    if (
      Number(seriesList.endingNumber) <
      Number(seriesList.startNumber)
    ) {
      return Swal.fire({
        icon: "error",
        text: "Ending Number must be greater than Starting Number!",
        toast: true,
        position: "top-end",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar:true
      });
    }

    const payload = {
      departmentId: selectedDepartment?.value || null,
      departmentName: selectedDepartment?.label || null,
      startingNumber: seriesList.startNumber,
      endingNumber: seriesList.endingNumber,
      sewadarId,
      email
    };

    try {
      const url = editId
        ? `${SERVER_BASE}/update-Series/${editId}`
        : `${SERVER_BASE}/save-series`;

      const method = editId ? "put" : "post";

      await apiClient[method](url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire({
        icon: "success",
        title: "Series Saved Successfully!",
        toast: true,
        position: "top-end",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar:true
      });

      navigate("../SeriesMasterList");
    } catch (error) {
      console.error("Save error:", error);
      Swal.fire({
        icon: "error",
        text: error.response?.data?.message || "Something went wrong!",
        toast: true,
        position: "top-end",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar:true
      });
    }
  };

  /* ---------------- UI ---------------- */
  return (
    <div className="formcontainer mt-5 p-4 border rounded bg-light shadow">
      <div className="d-flex justify-content-between align-items-end mb-3">
        <div className="d-flex">
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => navigate("../SeriesMasterList")}
          >
            <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
          </button>
          <h4 className="ms-2 mb-0">Series Master</h4>
        </div>
        <h6 className="mb-0">{editId ? "Editing..." : ""}</h6>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          {/* Department */}
          <div className="col-md-4">
            <label className="form-label">Department</label>
            <Select
              isLoading={loadingDepartments}
              options={departments.map((d) => ({
                label: d.name,
                value: d.id,
              }))}
              value={selectedDepartment}
              onChange={setSelectedDepartment}
              placeholder="Select Department"
            />
          </div>

          {/* Starting Number */}
          <div className="col-md-2">
            <label className="form-label">Starting Number</label>
            <input
              type="number"
              className="form-control"
              value={seriesList.startNumber}
              onChange={(e) =>
                handleChange("startNumber", e.target.value)
              }
            />
          </div>

          {/* Ending Number */}
          <div className="col-md-2">
            <label className="form-label">Ending Number</label>
            <input
              type="number"
              className="form-control"
              value={seriesList.endingNumber}
              onChange={(e) =>
                handleChange("endingNumber", e.target.value)
              }
            />
          </div>

          {/* Submit */}
          <div className="col-md-2 mt-5">
            <button className="btn btn-success w-100" type="submit">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SeriesMaster;
